const disclaimer = (
  <div>
    <p className='subtitle mb-20'>Disclaimer</p>
    <p className='subtitle mb-20'>
      This information is provided "as is" without warranty of any kind, either
      expressed or implied, including, but not limited to, the implied
      warranties of merchantability, fitness for a particular purpose, or
      non-infringement. In no event shall Alvaro Fitness be liable for any
      special, incidental, indirect, or consequential damages of any kind, or
      any damages whatsoever resulting from loss of use, data, or profits,
      whether or not advised of the possibility of damage under any theory of
      liability, arising out of or in connection with the use or performance of
      this information. This information could include technical inaccuracies or
      typographical errors. Changes may be added periodically to the information
      contained in any of our web pages or sites.
    </p>
    <p className='subtitle mb-20'>
      Because this website deals with issues of a health-related nature, we
      hereby state that Alvaro Fitness does not offer medical advice. Readers
      should seek medical advice from a licensed physician and not rely solely
      on information they may gather from secondary sources such as the
      Internet. Alvaro Fitness cannot be held responsible for the validity of
      the information contained in any reference noted herein, nor for the
      misuse of information or any adverse effects from the use of any stated
      materials presented herein.
    </p>
    <p className='subtitle mb-20'>
      This content is intended to offer factual, up-to-date information on the
      subjects discussed, but in no way should it be regarded as a complete
      analysis of these subjects. Physicians and other medical professionals
      should be consulted prior to implementing any items presented. No party
      associated in any way with this site or its content assumes liability for
      any loss or damage resulting from the use or misuse of any information
      contained herein or for any errors or omissions.
    </p>
    <p className='subtitle mb-20'>
      <strong>Important Note:</strong> Results in fitness and nutrition programs
      may vary from person to person. Individual results depend on various
      factors including, but not limited to, adherence to the program, genetics,
      lifestyle, and overall health. It is recommended to consult with a
      qualified fitness or healthcare professional before starting any fitness
      or nutrition program.
    </p>
    <p className='subtitle mb-20'>
      If you have any further questions or concerns, please contact us at{' '}
      <a href='mailto:contact@alvarofitness.com'>contact@alvarofitness.com</a>.
    </p>
  </div>
);

const privacyPolicy = (
  <div>
    <p className='subtitle mb-20'>Privacy Policy</p>
    <p className='subtitle mb-20'>
      <em>Last updated: July 2026</em>
    </p>
    <p className='subtitle mb-20'>
      Thank you for your interest in Alvaro Fitness. This Privacy Policy
      explains what information we collect, how we use it, and the choices you
      have. We are committed to protecting your privacy.
    </p>

    <p className='subtitle mb-20'>
      <strong>Information we collect.</strong> When you visit our website, our
      server automatically logs non-identifying statistical information such as
      your IP address, browser type, and referring site. This information is
      used only in aggregate to understand and improve how the site is used.
      When you submit a form — for example, to request a free consultation — we
      collect the information you provide, such as your name, phone number,
      email address, and your fitness goals, so that we can contact you and
      provide our services.
    </p>

    <p className='subtitle mb-20'>
      <strong>How we use your information.</strong> We use the information you
      provide to respond to your request, schedule and deliver consultations
      and coaching, communicate with you about our services, and improve our
      website. We do not sell your personal information.
    </p>

    <p className='subtitle mb-20'>
      <strong>SMS / text messaging.</strong> When you submit your phone number
      through a form on our site, you consent to be contacted by Alvaro Fitness
      by phone, text message (SMS), and email regarding your consultation and
      services. Message frequency varies. Message and data rates may apply. You
      can reply STOP at any time to opt out, or HELP for help. We do not sell,
      rent, or share your mobile phone number or your SMS opt-in consent with
      any third parties or affiliates for their marketing or promotional
      purposes. Information obtained as part of the SMS consent process will not
      be shared with third parties.
    </p>

    <p className='subtitle mb-20'>
      <strong>Cookies and advertising.</strong> We use cookies to remember your
      preferences, such as showing a message only once per visit. Third-party
      advertising partners, including Google, may use cookies to serve
      interest-based ads based on your visits to this and other sites. These
      ad-network cookies rely on non-personally-identifiable information and do
      not include the phone number or SMS consent you provide to us. You can
      manage interest-based advertising through your Google Ads settings and the
      Digital Advertising Alliance's opt-out tools.
    </p>

    <p className='subtitle mb-20'>
      <strong>Third-party links.</strong> Our site may contain links to other
      websites. Alvaro Fitness is not responsible for the privacy practices or
      the content of those sites.
    </p>

    <p className='subtitle mb-20'>
      <strong>Changes to this policy.</strong> We may update this policy from
      time to time, and any changes will be posted on this page. If you have
      questions about how your information is used, please contact us at{' '}
      <a href='mailto:contact@alvarofitness.com'>contact@alvarofitness.com</a>.
    </p>
  </div>
);

const termsOfService = (
  <div>
    <p className='subtitle mb-20'>Terms of Service</p>
    <p className='subtitle mb-20'>
      <em>Last updated: July 2026</em>
    </p>
    <p className='subtitle mb-20'>
      These Terms of Service ("Terms") govern your use of the Alvaro Fitness
      website and services. By accessing this site or using our services, you
      agree to these Terms. If you do not agree, please do not use the site or
      our services.
    </p>

    <p className='subtitle mb-20'>
      <strong>Services.</strong> Alvaro Fitness provides in-person personal
      training, nutrition guidance, and related coaching in Dallas, Texas, along
      with a complimentary initial consultation. Specific program details,
      pricing, and scheduling are provided separately and agreed upon before you
      begin.
    </p>

    <p className='subtitle mb-20'>
      <strong>Eligibility.</strong> You must be at least 18 years old to use our
      services, or have the consent and supervision of a parent or legal
      guardian.
    </p>

    <p className='subtitle mb-20'>
      <strong>Health acknowledgment and assumption of risk.</strong> Physical
      exercise carries inherent risks. You should consult a physician before
      beginning any fitness or nutrition program. By participating, you
      represent that you are physically able to do so and voluntarily assume the
      risks associated with physical activity. Alvaro Fitness does not provide
      medical advice; please also review our Disclaimer.
    </p>

    <p className='subtitle mb-20'>
      <strong>Your responsibilities.</strong> You agree to provide accurate
      information, to disclose any relevant health conditions, and to follow all
      guidance at your own discretion and risk.
    </p>

    <p className='subtitle mb-20'>
      <strong>Communications.</strong> When you submit a form on our site, you
      consent to be contacted by phone, text message (SMS), and email as
      described in our Privacy Policy. You may reply STOP at any time to opt out
      of text messages.
    </p>

    <p className='subtitle mb-20'>
      <strong>Payments and refunds.</strong> Fees for paid programs are
      described to you at sign-up. Any cancellation or refund terms are set out
      in your specific program agreement.
    </p>

    <p className='subtitle mb-20'>
      <strong>Intellectual property.</strong> All content, materials, and app
      access provided by Alvaro Fitness are owned by or licensed to Alvaro
      Fitness and may not be copied, resold, or redistributed without our
      written permission.
    </p>

    <p className='subtitle mb-20'>
      <strong>Limitation of liability.</strong> To the maximum extent permitted
      by law, Alvaro Fitness shall not be liable for any indirect, incidental,
      or consequential damages arising out of or relating to your use of the
      site or services.
    </p>

    <p className='subtitle mb-20'>
      <strong>Changes to these Terms.</strong> We may update these Terms from
      time to time, and any changes will be posted on this page.
    </p>

    <p className='subtitle mb-20'>
      <strong>Governing law.</strong> These Terms are governed by the laws of
      the State of Texas, without regard to its conflict-of-laws rules.
    </p>

    <p className='subtitle mb-20'>
      If you have any questions about these Terms, contact us at{' '}
      <a href='mailto:contact@alvarofitness.com'>contact@alvarofitness.com</a>.
    </p>
  </div>
);

export { disclaimer, privacyPolicy, termsOfService };
